var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgNotMarried(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#D6E8F6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-10.8028 71.5636L-2.57456 70.7784C-1.91483 70.7153 -1.29081 71.09 -1.03615 71.7021L5.17602 86.6481C5.56586 87.5863 4.93636 88.6334 3.92463 88.7302L-4.63703 89.5476C-5.30842 89.6113 -5.94077 89.2234 -6.18686 88.5963L-12.0656 73.6179C-12.4319 72.6843 -11.8021 71.6595 -10.8028 71.5636Z",
    fill: "#233862"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-2.58774 98.2485C-2.73244 98.3731 -9.64931 91.3057 -13.3428 87.39L-9.64313 85.1389L10.5575 97.8144L-2.58774 98.2485Z",
    fill: "#FFB27D"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.5106 14.9805C53.6415 14.3625 55.2884 7.74682 65.5603 9.17267C65.5603 9.17267 60.4363 8.89768 59.1844 10.9527C59.1844 10.9527 63.078 8.82156 65.7079 10.1827C68.3401 11.5436 69.1255 16.7032 68.8637 18.3096C68.5995 19.9158 66.1529 24.8159 64.3109 24.9479C63.6111 24.9981 62.8496 24.8195 62.1689 24.5785C62.5116 25.3937 62.8329 26.2834 63.1161 27.2639C65.7341 36.3312 60.1102 43.7695 56.8187 42.267C54.7077 41.3034 53.4249 44.9674 53.4249 44.9674L34.9619 23.8396C34.9619 23.8396 45.6972 8.88793 53.5106 14.9805Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.6172 71.6371C37.0262 73.3073 40.0464 74.6846 43.8376 75.5591C58.0484 78.8409 63.4937 66.8358 65.5405 58.5951C63.6008 57.4866 61.7778 57.2423 60.7258 57.1167C59.6977 56.9956 58.6172 56.9152 57.7223 56.871C56.1277 55.6492 53.7501 50.6492 53.2242 42.8865L52.5554 43.0656L41.3553 46.1295C41.3553 46.1295 41.867 49.6879 42.1193 53.0516C42.3145 55.6832 42.3454 58.1986 41.8456 58.814C40.9722 59.0033 40.4462 59.1273 40.4462 59.1273C40.4462 59.1273 40.4462 59.1311 40.4414 59.1377C40.2915 59.3842 37.0405 64.7251 34.6172 71.6371Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.3555 46.1311C41.3555 46.1311 41.8695 49.6867 42.1194 53.0531C48.4644 52.418 51.4084 46.3799 52.5555 43.0676L41.3555 46.1311Z",
    fill: "#BF9976"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.4596 49.4723C39.4596 49.4723 54.52 48.6418 53.8584 39.2751C53.1967 29.9085 54.6937 23.4929 45.0501 23.6273C35.4056 23.7615 33.792 27.4674 33.252 30.6474C32.7122 33.8279 35.5236 49.4473 39.4596 49.4723Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3266 25.4087C35.4496 22.4247 37.2519 22.9167 38.2967 23.6931C46.1958 18.5856 51.9719 24.8858 51.9719 24.8858C53.4618 31.5339 58.5859 35.0359 58.5859 35.0359C58.5859 35.0359 55.9655 36.9252 49.5277 35.7539C47.5619 35.3958 45.7388 34.1479 44.1538 32.5896C47.0192 36.6921 50.7225 39.53 50.7225 39.53C42.9233 36.5831 39.1368 26.3043 38.756 25.2158C37.8969 26.1061 36.2142 28.0266 35.7889 29.8211C35.2104 32.2599 35.2251 37.194 33.7817 37.1293C33.7817 37.1293 30.1425 29.8834 33.3266 25.4087Z",
    fill: "#2C3A64"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0209 58.3741C37.0209 58.3741 61.5583 52.4202 72.2253 61.2149L63.8207 98.3743L66.8942 135.536L18.9092 123.949C18.9092 123.949 20.2593 119.246 29.4607 106.741C38.6631 94.2352 34.6598 75.8921 37.0209 58.3741Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.532 82.4127C74.3491 91.3537 69.6106 102.295 67.9185 108.184C67.9185 108.184 70.7459 128.631 68.0446 134.245C67.74 134.885 67.3592 135.333 66.8927 135.535C56.8874 139.891 17.9222 135.661 16.2774 123.097C15.6796 118.533 31.1193 102.475 32.0189 100.527C32.3928 99.7211 32.79 97.1087 30.9803 91.6946C28.4142 99.6015 23.6755 108.732 18.9085 110.289C13.6702 112.002 -7.04311 96.5744 -7.04311 96.5744C-7.04311 96.5744 -7.16258 94.7004 -4.54415 92.928C-2.86033 91.788 1.0071 91.4039 1.0071 91.4039L14.2523 97.328C15.9145 94.4854 20.0558 74.8184 24.6794 65.9407C28.1558 59.267 37.4383 58.3002 37.4383 58.3002C37.4383 58.3002 41.301 64.4247 50.6447 63.556C59.9861 62.6875 61.6949 56.9712 61.6949 56.9712C61.6949 56.9712 69.9819 58.0721 72.5332 60.131C72.9759 60.488 77.0861 70.6988 75.532 82.4127Z",
    fill: "#3D83BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.9191 108.184C67.9191 108.184 70.7465 128.631 68.0453 134.245C60.7554 130.587 51.2546 122.693 54.1463 110.358C58.3469 92.4371 75.5326 82.4126 75.5326 82.4126C74.3498 91.3536 69.6113 102.295 67.9191 108.184Z",
    fill: "#1E5D8F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.6963 56.9712C61.6963 56.9712 73.732 58.3982 77.0449 63.5559C81.2336 70.0777 90.9691 86.1379 90.6502 92.6832C90.6502 92.6832 90.2437 95.9352 66.6664 116.26C66.6664 116.26 60.2324 114.795 65.4469 111.789C65.4469 111.789 79.7794 91.3779 81.2455 90.0867L71.3639 79.5917L61.6963 56.9712Z",
    fill: "#3D83BB"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-12.5942 71.7261L-4.36572 70.9404C-3.70599 70.8776 -3.08173 71.2523 -2.82755 71.8644L3.38486 86.8106C3.7747 87.7483 3.14544 88.796 2.13371 88.8923L-6.42819 89.7099C-7.09958 89.7739 -7.73193 89.3857 -7.97826 88.7581L-13.8565 73.7805C-14.223 72.8463 -13.5931 71.8213 -12.5942 71.7261Z",
    fill: "#2B478B"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgNotMarried);
export default __webpack_public_path__ + "static/media/imgNotMarried.9ecf84dc336c368d43e3913f58d77032.svg";
export { ForwardRef as ReactComponent };